import BaseConfig from './BaseConfig'
import DefaultConfig from './DefaultConfig.js'
import { Storage } from './../../Storage.js'

function LanguageConfig () {
    function extractKeywords () {
        let keywords = []
        for (let item in BaseConfig) {
            if (BaseConfig[item].keywords !== undefined) {
                for (let keyword of BaseConfig[item].keywords) {
                    keywords.push(keyword)
                }
            }
        }
        return keywords
    }

    let _keywords = extractKeywords()
    let autocomplete = true
    let caseSensitive = false
    let customLanguage = false
    let selection = Storage.getLanguageSelection()
    let config = Storage.getLanguageConfig()
    let name = ''
    let keywords = {}

    if (selection === 'custom' && config != null) {
        customLanguage = true
        keywords = config.keywords
        name = config.name
    } else {
        Storage.setLanguageSelection('default')
        keywords = DefaultConfig.keywords
    }

    for (let item in keywords) {
        if (BaseConfig[item] !== undefined) {
            BaseConfig[item].keywords = keywords[item]
        }
    }

    return {
        getName () {
            return name
        },
        getTokens () {
            return BaseConfig
        },
        isCustomLanguage () {
            return customLanguage
        },
        isAutocomplete () {
            return autocomplete
        },
        isCaseSensitive () {
            return caseSensitive
        },
        setCaseSensitive (newVal) {
            caseSensitive = newVal
        },
        setAutocomplete (newVal) {
            autocomplete = newVal
        },
        keywords () {
            return _keywords
        }
    }
}

export default LanguageConfig



// WEBPACK FOOTER //
// ./src/Core/Language/LanguageConfig.js